import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManualReportPageRoutingModule } from './manual-report-routing.module';

import { ManualReportPage } from './manual-report.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManualReportPageRoutingModule
  ],
  declarations: [ManualReportPage],
  exports: [
    ManualReportPage
  ],
})
export class ManualReportPageModule {}
